var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolPage"},[_vm._m(0),_c('div',{staticClass:"tool_item flex-rowc",on:{"click":_vm.backTop}},[_c('i',{staticClass:"iconfont icon-arrow"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool_item flex-rowc"},[_c('i',{staticClass:"iconfont icon-liebiaofenlei"})])
}]

export { render, staticRenderFns }